module.exports = "/images/home-ownership.png?b34325e30747a96f8c6e727ac09b2ce8";